// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientPayDescription_container__2UXfJ","cost":"ClientPayDescription_cost__1VMpV"};